<template>
  <div class="advantage">
    <div class="wrapper">
      <p class="pub-title">品牌优势</p>
      <p class="pub-sub-title">branded advantages</p>
      <div class="box">
        <img class="ani" id="img" :src="list[now].img" alt="" />
        <div>
          <div class="left" @click="now = now > 0 ? now - 1 : 0">前</div>
          <div class="content ani" id="content">
            <p class="title">{{ list[now].title }}</p>
            <div class="desc">
              {{ list[now].intro }}
            </div>
          </div>
          <div
            class="right"
            @click="now = now == list.length - 1 ? now : now + 1"
          >
            后
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { branded_advantages } from '../../utils/api'
export default {
  data() {
    return {
      now: 0,
      list: [],
    }
  },
  beforeUpdate() {
    document.getElementById('content').style.opacity = 0
    document.getElementById('img').style.opacity = 0
  },
  updated() {
    setTimeout(() => {
      document.getElementById('content').style.opacity = 1
      document.getElementById('img').style.opacity = 1
    }, 200)
  },
  mounted() {
    branded_advantages((r) => {
      this.list = r.data
    })
  },
}
</script>

<style lang="less" scoped >
.advantage {
  padding: 80px 0;
  .wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    .box {
      width: 100%;
      margin-top: 40px;
      img {
        width: 100%;
        height: 400px;
        vertical-align: middle;
        transition: all 0.15s linear;
      }
      div {
        display: flex;
        align-items: center;
        .left,
        .right {
          width: 80px;
          height: 120px;
          background: #ffffff;
          text-align: center;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #1a1a1a;
          transition: all 0.15s linear;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
        }
        .left:hover,
        .right:hover {
          background: #ededed;
          color: #006C8F;
        }
        .content {
          transition: all 0.15s linear;
          width: calc(100% - 160px);
          box-sizing: border-box;
          padding: 0 40px;
          border-right: 1px solid #c8c8c8;
          border-left: 1px solid #c8c8c8;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          .title {
            font-size: 22px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #1a1a1a;
            margin-bottom: 10px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            width: 100%;
            text-align: center;
          }
          .desc {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            line-height: 22px;
            color: #4d4d4d;
            text-align: center;
          }
        }
      }
    }
  }
}
@media (max-width: 767px) {
  .advantage {
    padding-top: 0.68rem ;
    .wrapper {
      .box {
        margin-top: 0;
        img {
          height: 2.5rem;
        }
        div {
          height: 3.32rem;
          .left,
          .right {
            width: 0.8rem;
            color: #006C8F;
            font-size: 0.28rem;
            background: #f5f5f5;
            height: 100%;
          }
          .content {
            width: calc(100% - 1.6rem);
            border: none;
            padding: 0 0.24rem;
            .title {
              font-size: 0.32rem;
              margin-bottom: 0.12rem;
              height: unset;
            }
            .desc {
              font-size: 0.26rem;
              color: #4d4d4d;
              height: unset;
            }
          }
        }
      }
    }
  }
}
</style>